(ns arthur.events.history
  "Undo and redo: `domain/history` against the open document, and the keys.

  An undone step is an ordinary unsaved edit afterwards, and the next save sends
  it — so undo reaches a collaborator the way any change of yours does."
  (:require [arthur.domain.history :as history]
            [arthur.domain.leaf :as leaf]
            [arthur.events.edit :as edit]
            [arthur.events.playback :as pb]
            [arthur.events.ui :as ui]
            [arthur.footage.store :as store]
            [re-frame.core :as rf]))

(defn- step
  "One step of `move` on `db`: `{:db :fps :ok?}`, `:ok?` false when there was
  nothing to do or the step was refused."
  [db move done]
  (let [entry  (store/entry (:clip/current db))
        leaves (edit/leaves (:clip entry))
        r      (when leaves (move (:history entry) leaves))]
    (cond
      (nil? r)
      {:db (assoc-in db [:project :status] (str "nothing to " (subs done 0 4))) :ok? false}

      (:blocked r)
      {:db (-> (edit/replace-entry db #(assoc % :history (:history r)))
               (assoc-in [:project :status]
                         (str "not " done ": " (:label (:blocked r))
                              " — someone else has changed it since")))
       :ok? false}

      :else
      (let [clip (leaf/clip "u" (:leaves r))
            valid? (fn [[kind host node]]
                     (or (not= :node kind)
                         (nil? node)
                         (get-in clip [:symbols host :nodes node])))
            selections (vec (filter valid? (get-in db [:ui :selections])))
            primary (get-in db [:ui :selection])
            primary (if (valid? primary) primary (peek selections))
            label (:label (peek (get (:history r) (if (= done "undone") :undone :done))))]
        {:ok? true
         :db  (-> (edit/replace-entry db #(assoc % :clip clip :history (:history r)))
                  (edit/transport clip)
                  (assoc-in [:ui :selections] selections)
                  (assoc-in [:ui :selection] primary)
                  (assoc-in [:project :status] (str done " " label " · unsaved")))}))))

(defn- steps
  "`n` steps, stopping at the first that cannot be taken."
  [db move done n]
  (let [fps (get-in db [:clip :fps])
        db  (loop [db db n n]
              (let [r (step db move done)]
                (if (and (:ok? r) (< 1 n)) (recur (:db r) (dec n)) (:db r))))]
    (cond-> {:db db}
      (not= fps (get-in db [:clip :fps]))
      (assoc ::pb/seek! [(get-in db [:clip :fps]) (pb/frames db) (get-in db [:playback :frame])]))))

(rf/reg-event-fx ::undo (fn [{:keys [db]} [_ n]] (steps db history/undo "undone" (or n 1))))
(rf/reg-event-fx ::redo (fn [{:keys [db]} [_ n]] (steps db history/redo "redone" (or n 1))))

(rf/reg-event-db ::hold (fn [db _] (edit/history db history/hold)))
(rf/reg-event-db ::settle (fn [db _] (edit/history db history/settle)))

(rf/reg-sub
 ::steps
 ;; The history is on the entry, outside app-db; the revision is what moves
 ;; when the entry does, undo and redo included.
 (fn [db _]
   (:paint/revision db)
   (history/steps (:history (store/entry (:clip/current db))))))

